export default "/institutions/amazon.svg";